package com.demo.portfolio_demo.utils

import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.silk.theme.colors.ColorScheme

object CustomColorSchemes {

    val BlackAndWhite = object : ColorScheme {
        override val _50 = Color.rgb(0XFFFFFF)
        override val _100 = Color.rgb(0XFFFFFF)
        override val _200 = Color.rgb(0XFFFFFF)
        override val _300 = Color.rgb(0XFFFFFF)
        override val _400 = Color.rgb(0XFFFFFF)
        override val _500 = Color.rgb(0X000000)
        override val _600 = Color.rgb(0X000000)
        override val _700 = Color.rgb(0X000000)
        override val _800 = Color.rgb(0X000000)
        override val _900 = Color.rgb(0X000000)
    }
}